import { c as _c } from "react/compiler-runtime";
import BookingDetailMainPrice from './BookingDetailMainPrice';
import BookingDetailPriceDetail from './BookingDetailPriceDetail';
const BookingDetailPrice = props => {
    const $ = _c(7);
    let t0;
    if ($[0] !== props.calculatedPrice) {
        t0 = props.calculatedPrice && <BookingDetailPriceDetail {...props.calculatedPrice}/>;
        $[0] = props.calculatedPrice;
        $[1] = t0;
    }
    else {
        t0 = $[1];
    }
    let t1;
    if ($[2] !== props) {
        t1 = <BookingDetailMainPrice {...props}/>;
        $[2] = props;
        $[3] = t1;
    }
    else {
        t1 = $[3];
    }
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = <div className="price-data border-t border-gray-100 last:mb-2">{t0}{t1}</div>;
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    }
    else {
        t2 = $[6];
    }
    return t2;
};
export default BookingDetailPrice;
